
export const getToken = () => {
	const d = Date.now();
	const r = Math.round( Math.random() * 1000, 0 );
	const token = (d * r).toString();
	return token;
}